import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Star, Quote, ChevronLeft, ChevronRight } from "lucide-react";
import { Reveal } from "@/components/Motion";
import { api } from "@/App";

const TESTIMONIALS = [
  {
    name: "Shaswata Bose",
    course: "German A2 · B.Tech, NITK",
    quote: "The teaching experience is simply awesome. I've a really hectic weekly schedule and Sir understands this really well — there is never any pressure. The classes are fun and interactive. Within a span of 4 months, I mastered A2. If you want to learn German, look no further and enroll here.",
  },
  {
    name: "Karthik Rao",
    course: "German Course",
    quote: "Really love the way the faculty teach a foreign language in a friendly and interactive way. This is the ideal place to learn German as far as I know. Students really learn to converse in German, not only understand it.",
  },
  {
    name: "Tanusha Leanne Diaz",
    course: "German Course",
    quote: "The course is well designed to give you an all-round education in German. Mr. Govind and Mrs. Ragini are extremely dedicated — this class is not just about the books. They teach you to speak, listen to audios and watch short films that give you a glimpse of German life. Kudos to both for all the dedication.",
  },
  {
    name: "Lionel",
    course: "German Course",
    quote: "Great place to learn German with interactive sessions. We get to learn not only the German language but also their culture & lifestyles.",
  },
  {
    name: "Nagasimha",
    course: "German Course",
    quote: "Edvio Language Institute is one of its kind. The best place to learn German in Mangalore. Govind sir and Ragini madam go an extra mile to help us learn. A double thumbs up — I would recommend everyone to Edvio.",
  },
  {
    name: "Ashwin Shenoy",
    course: "German (Deutsch)",
    quote: "Excellent course! Sir & Ma'am are very dedicated towards teaching and make the learning curve as shallow as possible while still explaining the difficult intricacies of the language. Recommended for anyone who wants a good, all-round mastery of Deutsch.",
  },
  {
    name: "Apoorva Suvarna",
    course: "German · Now in Deutschland",
    quote: "A heartfelt thanks to Edvio Institute for teaching me Deutsch. Govind Sir and Ragini Madam are wonderful teachers and I had a very good time in the class. As the result, now I am in Deutschland, happy and contented. I highly recommend Edvio to those who want to learn German.",
  },
  {
    name: "Deepu Suresh",
    course: "German Course",
    quote: "Systematic and efficient ways of teaching. I was able to grasp the language faster than I thought and it is fun learning German here.",
  },
  {
    name: "Ashik K A",
    course: "German A1 – A2",
    quote: "Was totally worth the time I spent doing the A1 and A2 course at Edvio. They make the classroom alive. There were many activities and the learning process was enjoyable.",
  },
  {
    name: "Srinivas",
    course: "German Course",
    quote: "One of the best institutes in Mangalore to learn German language. I am so happy that I joined this institute for my course. My experience was too good here — the teaching was excellent.",
  },
  {
    name: "Jayasimha",
    course: "German · Higher Studies",
    quote: "EDVIO helped me a great deal to pursue my higher studies — knowing German is a must if you're planning education in Germany, and your search ends here. E: Excellent, D: Dedicated, V: Versatile, I: Institution, O: Opportunities.",
  },
  {
    name: "Sikandar Mirza",
    course: "German A1–A2 · 92/100 in Goethe Exam",
    quote: "The best German teaching institute in Mangalore. I completed my A1 attending only Sunday classes and scored 92/100 in the Goethe exam. The lecturers are friendly and patient and take every effort to make concepts easy. Stop searching and get yourself enrolled here.",
  },
  {
    name: "Bhoomika RL",
    course: "German A2 · Google Review",
    quote: "I recently completed my A2 German course at Edvio Institute, and it has been a wonderful learning experience. The classes were well-structured, engaging, and made learning German enjoyable.",
  },
  {
    name: "Mevil Dsa",
    course: "German A1 · Google Review",
    quote: "I was recommended by my friend to Edvio Language Institute to learn German. I've just completed my A1 level and am now starting A2, and the experience so far has been excellent.",
  },
  {
    name: "Srlinta Edathiparamban",
    course: "German Course · Google Review",
    quote: "This German course has been a really special experience for me. What I appreciated the most was the positive and friendly atmosphere in the class. It made it easy to participate and not to be afraid of making mistakes. I can clearly see how much I have improved.",
  },
];

export default function Testimonials() {
  return (
    <section id="stories" className="py-28 lg:py-40 bg-[#F4F4F0] text-[#0A0B0A]" data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <Reveal>
          <p className="text-xs uppercase tracking-[0.3em] text-[#C44900] mb-6" data-testid="testimonials-eyebrow">03 — Student Stories</p>
          <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6">
            <h2 className="font-display text-4xl sm:text-5xl lg:text-7xl tracking-tighter leading-[1.02] max-w-2xl">
              They came curious.<br /><em className="italic text-[#C44900]">They left fluent.</em>
            </h2>
            <div className="flex flex-col items-start lg:items-end gap-4">
              <div className="flex items-center gap-2 text-sm" data-testid="testimonials-rating">
                <span className="flex">
                  {[...Array(5)].map((_, i) => <Star key={i} size={16} className="fill-[#C44900] text-[#C44900]" />)}
                </span>
                <span className="font-medium">5.0</span>
                <span className="text-[#0A0B0A]/60">on Google</span>
              </div>
              <a
                href="https://maps.app.goo.gl/pqNsmLFhdkYW1NUt8"
                target="_blank"
                rel="noopener noreferrer"
                className="group flex items-center gap-2 bg-[#0A0B0A] text-[#F4F4F0] text-xs uppercase tracking-[0.18em] px-6 py-3 rounded-full hover:bg-[#C44900] transition-colors duration-300"
                data-testid="google-review-button"
              >
                Write a review on Google
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5"><path d="M7 17L17 7M7 7h10v10"/></svg>
              </a>
            </div>
          </div>
        </Reveal>

        <Carousel />
      </div>
    </section>
  );
}

function Carousel() {
  const [reviews, setReviews] = useState(TESTIMONIALS);
  const [page, setPage] = useState(0);

  useEffect(() => {
    api.get("/reviews")
      .then((r) => { if (Array.isArray(r.data) && r.data.length) setReviews(r.data); })
      .catch(() => {});
  }, []);

  const pages = [];
  for (let i = 0; i < reviews.length; i += 3) pages.push(reviews.slice(i, i + 3));

  useEffect(() => {
    const t = setInterval(() => setPage((p) => (p + 1) % pages.length), 6000);
    return () => clearInterval(t);
  }, [pages.length]);

  const prev = () => setPage((p) => (p - 1 + pages.length) % pages.length);
  const next = () => setPage((p) => (p + 1) % pages.length);

  return (
    <div className="mt-16 lg:mt-24" data-testid="testimonials-carousel">
      <AnimatePresence mode="wait">
        <motion.div
          key={page}
          initial={{ opacity: 0, x: 70 }}
          animate={{ opacity: 1, x: 0 }}
          exit={{ opacity: 0, x: -70 }}
          transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
          className="grid md:grid-cols-3 gap-6"
        >
          {pages[page].map((t, i) => (
            <figure
              key={t.name}
              className="group h-full bg-white border border-[#0A0B0A]/10 rounded-lg p-8 lg:p-10 flex flex-col justify-between transition-transform duration-500 hover:-translate-y-2"
              data-testid={`testimonial-card-${page * 3 + i}`}
            >
              <div>
                <Quote size={28} className="text-[#C44900] mb-6" />
                <blockquote className="font-display text-lg lg:text-xl leading-snug tracking-tight">{t.quote}</blockquote>
              </div>
              <figcaption className="mt-8 pt-6 border-t border-[#0A0B0A]/10">
                <p className="text-sm font-medium">{t.name}</p>
                <p className="text-xs uppercase tracking-[0.2em] text-[#0A0B0A]/50 mt-1">{t.course}</p>
              </figcaption>
            </figure>
          ))}
        </motion.div>
      </AnimatePresence>

      <div className="mt-10 flex items-center justify-between">
        <div className="flex items-center gap-2">
          {pages.map((_, i) => (
            <button
              key={i}
              onClick={() => setPage(i)}
              aria-label={`Go to reviews page ${i + 1}`}
              className={`h-1.5 rounded-full transition-[width,background-color] duration-400 ${i === page ? "w-8 bg-[#C44900]" : "w-3 bg-[#0A0B0A]/20 hover:bg-[#0A0B0A]/40"}`}
              data-testid={`testimonial-dot-${i}`}
            />
          ))}
        </div>
        <div className="flex items-center gap-3">
          <button
            onClick={prev}
            aria-label="Previous reviews"
            className="w-11 h-11 rounded-full border border-[#0A0B0A]/15 flex items-center justify-center text-[#0A0B0A]/60 hover:bg-[#0A0B0A] hover:text-[#F4F4F0] transition-colors duration-300"
            data-testid="testimonials-prev-button"
          >
            <ChevronLeft size={18} />
          </button>
          <button
            onClick={next}
            aria-label="Next reviews"
            className="w-11 h-11 rounded-full border border-[#0A0B0A]/15 flex items-center justify-center text-[#0A0B0A]/60 hover:bg-[#0A0B0A] hover:text-[#F4F4F0] transition-colors duration-300"
            data-testid="testimonials-next-button"
          >
            <ChevronRight size={18} />
          </button>
        </div>
      </div>
    </div>
  );
}
